import { capitalizeVariables } from 'util/strings.util';
import { TaskRowType } from '../../tasks/tasks.model';

/** Multi-word enum values need spelling out; the rest read as one word. */
export const getTaskTypeLabel = (type: TaskRowType): string => {
  if (type === TaskRowType.QuestionnaireRevision) return 'Questionnaire Revision';
  if (type === TaskRowType.RiskAssessment) return 'Risk Assessment';
  return capitalizeVariables(type) ?? '--';
};
